import React from "react";
import PropTypes from "prop-types";

const templates = [
  {
    label: "Facebook Ad",
    subtitle: "Conversions (Image Ad)",
    icon: "/images/facebook-logo.svg",
    message:
      "I'd like to create a Facebook image ad focused on driving conversions. The ad type is imageAd, the platform is Facebook, the project type is ad, and the goal is sales."
  },
  {
    label: "Google Search Ad",
    subtitle: "Text Only",
    icon: "/images/google-logo.svg",
    message:
      "I'd like to create a Google search ad. The ad type is textAd, the platform is Google, the project type is ad, and the goal is website-traffic."
  },
  {
    label: "Instagram Post",
    subtitle: "Social Post (Image)",
    icon: "/images/instagram-logo.svg",
    message:
      "I'd like to create an Instagram social post with an image. The ad type is imageAd, the platform is Instagram, the project type is socialPost, and the goal is engagement."
  }
];

const QuickStartTemplates = ({ onSelect }) => {
  return (
    <div className="flex justify-center gap-4 px-6 pb-4">
      {templates.map((tpl) => (
        <div
          key={tpl.label}
          onClick={() => onSelect(tpl.message)}
          className="flex w-[180px] cursor-pointer flex-col items-center rounded-xl border border-grey-17 px-4 py-5 transition-all duration-200 hover:border-transparent"
          style={{
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow =
              "0 0 0 2px #17c471, 0 4px 12px rgba(23,196,113,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)";
          }}
        >
          <img src={tpl.icon} alt={tpl.label} className="mb-3 size-8" />
          <span className="font-InterSemibold text-ft14-20 text-grey-12">
            {tpl.label}
          </span>
          <span className="mt-1 text-center font-InterRegular text-ft12-16 text-grey-14">
            {tpl.subtitle}
          </span>
        </div>
      ))}
    </div>
  );
};

QuickStartTemplates.propTypes = {
  onSelect: PropTypes.func.isRequired
};

export default QuickStartTemplates;
